import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { getErrorMessage } from 'utilities/ErrorHelper';
import { adminTrackmanParametersV2QueryKey } from './useTrackmanParametersV2';

type ResyncPayload = {
  id: string;
  language: string;
};

export const useResyncTrackmanParameterTranslationV2 = () => {
  const service = useServices().trackmanParametersV2Service;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: ({ id, language }: ResyncPayload) => service.resyncTranslation(id, language),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: adminTrackmanParametersV2QueryKey });
      notificationsStore.addToast('success', 'Parameter translation resynced successfully', 'success');
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
